var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlinkText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 894,
    height: 249,
    viewBox: "0 0 894 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 249V17.5259H80.1449C122.536 17.5259 145.387 42.6574 145.387 75.7251C145.387 98.8725 132.802 119.044 110.282 125.988V127.311C137.77 133.594 154.991 156.41 154.991 184.187C154.991 221.554 131.809 249 81.8008 249H0ZM27.4877 116.729H78.489C101.009 116.729 117.899 100.526 117.899 78.7012C117.899 56.5458 102.003 40.0119 76.1708 40.0119H27.4877V116.729ZM27.4877 226.514H77.8267C109.951 226.514 127.503 207.996 127.503 182.534C127.503 157.733 109.289 139.546 78.8202 139.546H27.4877V226.514Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M274.119 226.514H338.698V249H181.72V226.514H246.3V43.4382C246.3 35.154 239.584 28.4382 231.3 28.4382H186.72V5.95219H242.119C259.792 5.95219 274.119 20.2791 274.119 37.9522V226.514Z",
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M465.36 0V39.0199H437.872V0H465.36ZM466.685 226.514H531.264V249H374.286V226.514H438.866V99.5339H374.286V77.0478H466.685V226.514Z",
    fill: "#F1F1F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M643.045 71.4263C677.487 71.4263 701.001 95.5657 701.001 139.876V249H673.513V148.143C673.513 113.092 658.279 97.5498 633.772 97.5498C608.603 97.5498 587.407 122.681 587.407 154.426V249H559.588V77.0478H587.407V114.745H589.063C597.343 87.2988 617.876 71.4263 643.045 71.4263Z",
    fill: "#F1F1F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M856.577 249L797.627 152.442L758.88 187.163V249H731.392V5.95219H758.88V153.104L856.577 65.9118H894L818.16 134.255L887.377 249H856.577Z",
    fill: "#F1F1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlinkText);
export default __webpack_public_path__ + "static/media/blink-text.17dc3e65444e3f2a2a032f4dcf5d7fad.svg";
export { ForwardRef as ReactComponent };